import React, { Component } from "react";
import { Navbar, NavbarBrand } from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Header.css";

class Header extends Component { 
  constructor(props) {
    super(props);
    this.state = {
      showLogoutContainer: false
    }
  }

  toggleShowLogoutContainer() {
    this.setState({ showLogoutContainer: !this.state.showLogoutContainer });
  }

  logout = () => {
    this.props.auth.logout();
  };

  render() {
    const logo = "https://www.dtn.com/wp-content/uploads/2018/11/logo-dtn-white.png";
    return (
      <div className="header">
        <Navbar className="nav-bar" dark expand="md">
          <NavbarBrand to="/" tag={Link}>
            <img src={logo} alt="logo" className="logo"/>
            User Management
          </NavbarBrand>
          
          <div className="logout">
            <FontAwesomeIcon
              className="fas fa-user-circle user"
              icon="user-circle"
              size="2x"
              color="#ffffff"
              onClick={() => this.toggleShowLogoutContainer()}
            />

            {this.state.showLogoutContainer &&
              <div className="logout-container popover">
                <div className="popover-inner">
                  <FontAwesomeIcon
                    className="fas fa-caret-up arrow"
                    icon="caret-up"
                    size="2x"
                    color="#ffffff"
                  />
                  <button onClick={this.logout} className="logout-btn">
                    <FontAwesomeIcon
                      className="fas fa-sign-out-alt exit"
                      icon="sign-out-alt"
                      size="sm"
                      color="#212529"
                    />
                    <span>Log Out</span>
                  </button>
                </div>
              </div>
            }
          </div>
        </Navbar>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/common/Header/Header.js